import React from "react";
import { Spinner} from "react-bootstrap";

function LoadingDisplay(params) {
    const isLoading = params.loading;
    let spinner = <Spinner animation="border" role="status">
        <span className="sr-only">Loading...</span>
    </Spinner>
    return isLoading ? spinner: "";
}

export {LoadingDisplay}
